/**
 * Centralized query keys. Add a namespace per feature (reports, events, etc.).
 *
 * Pattern:
 * - `all` — invalidate everything in a namespace
 * - scoped keys — specific resources with stable serializable params
 */
export const queryKeys = {
    reports: {
        all: ['reports'] as const,
        library: (eventId: number) => [...queryKeys.reports.all, eventId, 'library'] as const,
        data: (eventId: number, reportId: string, dateRangeKey: string) =>
            [...queryKeys.reports.all, eventId, reportId, dateRangeKey] as const,
        views: (eventId: number) => [...queryKeys.reports.all, eventId, 'views'] as const,
        view: (eventId: number, viewId: number) =>
            [...queryKeys.reports.all, eventId, 'views', viewId] as const,
        tickets: (eventId: number) => [...queryKeys.reports.all, eventId, 'tickets'] as const,
    },
    eventDashboard: {
        all: ['eventDashboard'] as const,
        stats: (eventId: number, timezone: string) =>
            [...queryKeys.eventDashboard.all, eventId, timezone, 'stats'] as const,
    },
} as const;
